import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DynamicInputFields } from '@components/dynamic-input-fields';
import { REQUIRED_TEXT_ERROR } from '@components/dynamic-input-fields/src/utils';
import { ErrorMessage } from '@components/error/src/error-message';
import { OPTION_FILL_INFO, OPTION_SEND_LINK } from '@components/process-invite-guest/src/process-invite-guest.type';
import { SelectItemOption } from '@components/select-item-option';

import { INFO_TYPE_FIELD, InviteGuestSingleInviteProps } from './invite-guest.types';
import { OptionalMailInput } from './optional-mail-input';

export const InviteGuestSingleInvite = ({ options, requiredFields, isoCode }: InviteGuestSingleInviteProps) => {
  const { t } = useTranslation();
  const { register, watch } = useFormContext();
  const watchedSelectedOption = watch(INFO_TYPE_FIELD);

  return (
    <div className='flex flex-col gap-3 px-4 pb-4 sm:gap-4 sm:px-20 sm:pb-12'>
      <section>
        <fieldset
          className='flex items-stretch gap-4'
          {...register(INFO_TYPE_FIELD, {
            required: watchedSelectedOption !== '' || t(REQUIRED_TEXT_ERROR),
          })}>
          {options.map((option) => (
            <SelectItemOption {...option} key={option.id} />
          ))}
        </fieldset>
        <ErrorMessage name={INFO_TYPE_FIELD} />
      </section>
      {watchedSelectedOption === OPTION_FILL_INFO && (
        <DynamicInputFields fields={requiredFields} venueIsoCode={isoCode} />
      )}
      {watchedSelectedOption === OPTION_SEND_LINK && <OptionalMailInput />}
    </div>
  );
};
